import 'dotenv/config';

const nodeEnv = process.env.REACT_APP_NODE_ENV;

let baseUrlQRCode;

if (nodeEnv === 'DEV') {
    baseUrlQRCode = {
        api: 'http://10.10.10.85:3333',
        front: 'http://10.10.10.85:3000'
    }
} else {
    baseUrlQRCode = {
        api: 'http://189.112.226.76:3333',
        front: 'http://189.112.226.76:3000'
    }
}

export { baseUrlQRCode };
